<template>
    <div :class="`${marginClass ? marginClass : 'mt-5'}`">
            <div :class="`${paddingClass ? paddingClass : 'px-3'}`">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    {{label}}
                    <span class="text-gray-500">{{sublabel}}</span>
                </label>

                <div class="d-flex align-items-center">
                    <div @click="decrement()" class=" plusminusBtn font-semibold  rounded focus:outline-none select-none  focus:shadow-lg text-white bg-purple-600 hover:bg-purple-700 font-bold text-2xl" :disabled="disabled" >
                        -
                    </div>
                    <input @input="onChange($event)" :name="name" pattern="^[0-9]$" type="text" :value="this.value" class=" text-center form-control w-75 mx-2" :disabled="disabled">
                    <div @click="increment()" class=" plusminusBtn font-semibold rounded focus:outline-none select-none  focus:shadow-lg text-white bg-purple-600 hover:bg-purple-700  font-bold text-2xl" :disabled="disabled" >
                       +
                    </div>
                </div>
            </div>
        </div>
</template>
<script>

export default {
    name: 'IncrementDecrementInput',
    props: {
        label: String,
        sublabel: String,
        marginClass:String,
        paddingClass:String,
        defValue:Number,
        name:String,
        getValue:{ type: Function },
        disabled:Boolean,
    },
    data(){
        return{
            value:0,
        }
    },
    mounted(){
        this.value = this.defValue ? this.defValue : 0;
    },
    watch: {
        value(value) {
            this.getValue(value)
        },
        defValue(defValue){
            this.value = defValue;
        }
    },
    methods:{
        increment() {
    const newValue = parseInt(this.value) + 1;
    if (this.getValue && !this.getValue(newValue)) {
        // Stop increment if `getValue` returns false
        this.value = this.defValue; // Reset to store value
        return;
    }
    this.value = newValue;
},
        decrement() {
    const newValue = parseInt(this.value) - 1;
    if (this.getValue && !this.getValue(newValue)) {
        // Stop decrement if `getValue` returns false
        return;
    }
    this.value = newValue;
},
        onChange(e){
            this.value = e.target.value;
         }
        }
}            


</script>